<template>
    <section class=" h-full">
        <p class="dark:text-gray-200 text-gray-700 text-2xl tracking-widest uppercase px-8 py-8">Exportar dados sobre Recolhas</p>
        <div class=" flex w-1/2 mx-auto flex-wrap content-start gap-y-4">
            <p class="dark:text-gray-200 text-gray-700 text-sm uppercase w-full">Selecione o Período</p>
            <span class="w-full">
                <DatePicker v-model="anomes" />
            </span>
            <button @click="exportRecolhas()" class="btn w-full col-span-2 bg-indigo-700 h-10 rounded-md uppercase text-gray-50 flex items-center justify-center" :disabled="loading">
                <span v-if="loading" class="w-auto h-full">
                    <Spinner width="4"/>
                </span>
                <span v-else>Exportar</span>
            </button>
        </div>
    </section>
</template>

<script>
import { ref } from '@vue/reactivity'
import DatePicker from '../Design/Datepicker.vue'
import Spinner from '../Design/Spinner.vue'
import { EXPORTAR_RECOLHAS } from '../../mixins/api'
import { displayNotification } from '../../mixins/notification'
export default {
    name: 'ExportarRecolhas',
    components: {
        DatePicker,
        Spinner
    },
    setup () {
        const anomes = ref('')

        const loading = ref(false)

        const exportRecolhas = async () => {
            loading.value = true
            await EXPORTAR_RECOLHAS(anomes.value).then(r => {
                displayNotification(r)
                let fileURL = window.URL.createObjectURL(new Blob([r.data]))
                let fileLink = document.createElement('a')
                fileLink.href = fileURL
                fileLink.setAttribute('download', `Relatorio_${anomes.value}.xlsx`)
                fileLink.click()
            }).catch(e => {
                displayNotification(e.response)
            })
            loading.value = false
        }

        return {
            anomes,
            loading,
            exportRecolhas
        }
    }
}
</script>
